export enum AmountStatus {
  EXACT = 0,
  OVERPAID = 1,
  UNDERPAID = 2,
  NOT_PAID = 3,
  REFUNDED = 4,
  PARTIALLY_REFUNDED = 5,
  EXPIRED = 6,
}
